module.exports = __webpack_public_path__ + "static/barrel_static-e6d77233804e6d7c7637162ec84c303b.png";